import React from 'react';
import AllSolutionsGrid from '../components/services/AllSolutionsGrid';

const AllSolutions = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-catalina-blue to-san-marino text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Solutions We Provide</h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              Comprehensive services and solutions to support all your material handling needs
            </p>
          </div>
        </div>
      </section>

      {/* Solutions Grid */}
      <AllSolutionsGrid />
    </div>
  );
};

export default AllSolutions;